// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap';

const NotEnoughAccess = () => {
    return (
        <React.Fragment>
            <div className="pt-2 pt-sm-5 pb-4 pb-sm-5">
                <div className="container">
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card>
                                <Card.Body className="p-4">
                                    <div className="text-center">
                                        <h4 className="text-uppercase text-danger mt-3">Not enough Access!</h4>
                                        <p className="text-muted mt-3">
                                            It seems you are not authorized to access this functionality. Contact your administrator if you think you need elevated access.
                                        </p>

                                        <Link className="btn btn-primary mt-3" to="/">
                                            <i className="mdi mdi-reply"></i> Return Home
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default NotEnoughAccess;
